import BaseException from '../base_exception'
import InvalidRejectReason from '../file_with_context_result/invalid_reject_reason'

class UnableToRead extends BaseException {
  constructor(fileWithContext) {
    super(InvalidRejectReason.REJECT_REASON.ERROR_READING, {
      fileWithContext,
    })
  }
}

export default UnableToRead
